// solidityTypes.json
const SOLIDITY_TYPES = {
  title: "Tipos de Datos en Solidity",
  sections: [
    {
      id: "hero",
      heading: "Introducción a los Tipos de Datos",
      text: `Solidity soporta tipos de datos estáticos y dinámicos. 
Son fundamentales para definir variables, parámetros de funciones y estructuras de contratos. 
No existen decimales de punto flotante: para valores con decimales se usan enteros escalados.`,
      note: `Tipos reservados fixed/ufixed NO están implementados.`
    },

    // --- Enteros sin signo ---
    {
      id: "uint",
      heading: "1) Enteros sin signo — uint",
      text: `Valores >= 0. Alias: uint == uint256. 
Tamaños disponibles: uint8, uint16 … hasta uint256 en saltos de 8 bits.`,
      list: [
        "Rango uint8: 0 → 255",
        "Rango uint256: 0 → 2²⁵⁶ − 1"
      ],
      code: `// Ejemplo de uint
uint a;           // == uint256
uint256 saldo;    // explícito
uint8 edad = 25;  // 0..255
uint256 supply = 1_000_000;`
    },

    // --- Enteros con signo ---
    {
      id: "int",
      heading: "2) Enteros con signo — int",
      text: `Admiten valores negativos y positivos. Alias: int == int256. 
Disponibles: int8, int16 … int256.`,
      list: [
        "Rango int8: −128 → +127",
        "Rango int256: −2²⁵⁵ → 2²⁵⁵ − 1"
      ],
      code: `int x;              // == int256
int256 temperatura; 
int8 delta = -32;   // -128..127
int256 balanceNeto = -150;`
    },

    // --- Booleanos ---
    {
      id: "bool",
      heading: "3) Booleanos — bool",
      text: `Solo aceptan true o false. Útiles para banderas, checks y lógicas de control.`,
      code: `bool isActive = true;
bool isPaused = false;`
    },

    // --- Texto y binarios ---
    {
      id: "string-bytes",
      heading: "4) Texto y Binarios — string, bytes, bytesN",
      list: [
        "string: texto dinámico UTF-8",
        "bytes: arreglo dinámico de bytes",
        "bytes1 … bytes32: tamaños fijos (1 a 32 bytes)"
      ],
      code: `string nombre = "Contrato";
bytes datos;        // dinámico
bytes32 idFijo;     // 32 bytes fijo
bytes4 selector;    // 4 bytes (function selector)`
    },

    // --- Direcciones ---
    {
      id: "address",
      heading: "5) Direcciones — address y address payable",
      text: `Representan cuentas o contratos (20 bytes). 
address payable permite enviar ETH (transfer, send, call{value:..}).`,
      code: `address owner = msg.sender;
address payable tesoreria;`
    },

    // --- Enums ---
    {
      id: "enum",
      heading: "6) Enums",
      text: `Definen conjuntos finitos de opciones con nombre, útiles para estados.`,
      code: `enum Estado { PENDIENTE, ACTIVO, INACTIVO }
Estado public actual = Estado.PENDIENTE;`
    },

    // --- Structs ---
    {
      id: "struct",
      heading: "7) Structs",
      text: `Agrupan variables bajo un mismo tipo definido por el usuario.`,
      code: `struct Usuario {
  string nombre;
  uint256 edad;
  address cuenta;
}
Usuario public u;`
    },

    // --- Arrays ---
    {
      id: "arrays",
      heading: "8) Arrays",
      text: `Colecciones de elementos del mismo tipo. 
Pueden ser de longitud fija o dinámica.`,
      codes: [
`uint256[] lista;         // dinámico
lista.push(10);`,
`uint256[5] fijos;        // tamaño fijo`,
`address[] public cuentas;`
      ]
    },

    // --- Mappings ---
    {
      id: "mappings",
      heading: "9) Mappings",
      text: `Diccionarios clave → valor. 
No se pueden iterar directamente.`,
      code: `mapping(address => uint256) balances;

balances[msg.sender] = 100;`
    },

    // --- Tipos especiales ---
    {
      id: "special",
      heading: "10) Tipos Especiales",
      list: [
        "msg: información de la llamada (sender, value, data)",
        "block: datos del bloque (timestamp, number, difficulty)",
        "tx: información de la transacción (origin, gasprice)"
      ],
      code: `address caller = msg.sender;
uint256 time = block.timestamp;
address origin = tx.origin;`
    },

    // --- Tipos reservados ---
    {
      id: "reserved",
      heading: "11) Tipos Reservados (NO implementados)",
      text: `fixed y ufixed están reservados para posibles decimales de punto fijo.
Actualmente no deben usarse en producción.`
    },

    // --- Aliases ---
    {
      id: "aliases",
      heading: "12) Aliases de Tipos",
      list: [
        "uint == uint256",
        "int == int256",
        "bytes == bytes1[] dinámico"
      ]
    },

    // --- Conclusión ---
    {
      id: "cierre",
      heading: "Conclusión",
      text: `Solidity ofrece enteros con y sin signo, booleanos, strings/bytes, direcciones, 
y tipos compuestos como structs, arrays, mappings y enums. 
Entender rangos y limitaciones evita errores de seguridad y optimiza gas.`
    }
  ]
};

export default SOLIDITY_TYPES;
